import type { IconSvgObject } from './types';

const DonutIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12.002", r: "3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 2.00195C17.5228 2.00195 22 6.47911 22 12.002C22 17.5248 17.5228 22.002 12 22.002C6.47715 22.002 2 17.5248 2 12.002C2 10.8237 2.20484 9.69333 2.5791 8.64355C3.00215 8.87159 3.48571 9.00195 4 9.00195C5.65685 9.00195 7 7.65881 7 6.00195C8.65685 6.00195 10 4.65881 10 3.00195C10 2.7331 9.96086 2.47352 9.89453 2.22559C10.5735 2.08007 11.2776 2.00195 12 2.00195Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default DonutIcon;
